var _path, _path2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSideMenuCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 0.5H16.25C18.0449 0.5 19.5 1.95507 19.5 3.75V16.25C19.5 18.0449 18.0449 19.5 16.25 19.5H3.75C1.95507 19.5 0.5 18.0449 0.5 16.25V3.75C0.5 1.95507 1.95507 0.5 3.75 0.5Z",
    stroke: "#0D0D0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.65625L9.34399 10.0002L6 13.3442",
    stroke: "#295EF1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 1,
    x2: 13.5,
    y2: 20,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSideMenuCollapse);
export default __webpack_public_path__ + "static/media/icon-side-menu-collapse.e3253006d973d30d9175658b3d761a0f.svg";
export { ForwardRef as ReactComponent };